export const APP_VERSION = process.env.REACT_APP_VERSION || '1.1.0';